import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import ListingCardView from '../ListingCardView'

const PropertyListings = ({ listings, markListingAsSaved }) => {
  const getListingsContent = useCallback(() => listings.map((listing, i) => (
    <ListingCardView key={listing.id} listing={listing} markListingAsSaved={markListingAsSaved} isEagerLoad={i <= 6}/>
  )), [listings])

  return (
    <ul
      className='PropertyListings'
      data-sprinkle='save-scroll-position'
      data-storage_key='searchScrollPosition'
      data-scroller_node_id='site-scroller'
    >
      {getListingsContent()}
    </ul>
  )}

PropertyListings.propTypes = {
  listings: PropTypes.array,
  markListingAsSaved: PropTypes.func
}

export default PropertyListings
